import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_55apzekrkm: FaireBrandEntity = {
  token: "b_55apzekrkm",
  type: "brand",
  name: "Spark Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/a2748948a9cfa0e090ee59f72c449a7dd9ec422e1952c7264a17977dae924a5f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bf4b18c190c332da4a451962dd766d6b752656291a9efe99bc718fe6a16ab836.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a2748948a9cfa0e090ee59f72c449a7dd9ec422e1952c7264a17977dae924a5f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bf4b18c190c332da4a451962dd766d6b752656291a9efe99bc718fe6a16ab836.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 14,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "We are brothers & health enthusiasts with hearty midwest roots and a passion for food. Together we are reclaiming the flavor of food using the highest quality organic ingredients.\n\n We both love fruity snacks, but started to wonder, where is the fruit? That’s when we set out to create our own fruit chews that we felt good about eating!\n\nOur chews are certified Organic, non-GMO, Kosher, Vegan, gluten free and each pouch contains ½ a serving of fruit. We also help reduce food waste by using blemished fruit that was not pretty enough for the produce aisle!\n\n At Spark Organics, our goal is to bring you snacks that are guilt-free and taste amazing! Our chews taste like real fruit because that's what they’re made of!  \n\nHappy Snacking,\nJonathan & Christian",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:16.513Z",
    importedBy: "entity-db-cli",
  },
};
